import { createContext, useContext } from "react";

export interface PrescreenData {
  age: number;
  bmi: number;
  sex?: string;
  medications: string[];
  diagnoses: string[];
  onInsulin: boolean;
  // Play 2 — GLP-1 Recovery segment inputs (optional; stripped client-side
  // when the user answers "No" to ever having taken a GLP-1).
  previousGlp1Use?: boolean;
  glp1LastUseDate?: string;
  glp1DiscontinuationReason?: string;
}

export type IntakeSegment = "standard" | "glp1_recovery";

export interface IntakeState {
  token: string | null;
  prescreen: PrescreenData | null;
  prescreenResult: {
    status: string;
    reasons: string[];
    nextStep: string;
    tier: number | null;
    segment?: IntakeSegment | null;
  } | null;
  consentVersion: string | null;
  completeResult: { registryId: string; siteAssignment: { id: string; name: string; city: string; state: string } | null } | null;
}

export interface IntakeContextType extends IntakeState {
  setToken: (t: string) => void;
  setPrescreen: (p: PrescreenData) => void;
  setPrescreenResult: (r: IntakeState["prescreenResult"]) => void;
  setConsentVersion: (v: string) => void;
  setCompleteResult: (r: IntakeState["completeResult"]) => void;
}

export const IntakeContext = createContext<IntakeContextType | null>(null);

export function useIntake() {
  const ctx = useContext(IntakeContext);
  if (!ctx) throw new Error("useIntake must be used within IntakeProvider");
  return ctx;
}
